/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { ModalViewReport } from '../components/ModalViewReports';
import DateSelector from './components/DateInput';

//import { ModalAddUpdateUser } from '../components/ModalAddEditUser';
//import { ModalDeleteUser } from '../components/ModalDeleteUser';
// import { ModalCreateCredential } from '../../../portals/components/modalCreateCredential';
// import { ModalAddUpdateClient } from '../ModalAddEditClient';
// import { ModalDeleteClient } from '../ModalDeleteClient';
// import { ModalDetailsClient } from '../ModalDetailsClient';
import { TableBody } from './TableBody';
import { useToast } from '../../../components/Toats';
import { useAuth } from '../../../../modules/auth';
import { SearchInputV3 } from '../../../components/SearchInputV3';
import { Loading } from '../../../components/Loadings/loading';
import { PaginationTablePlants } from '../../../dashboard/TablePlants/components/Pagination';
import { getReportsGenerationAllPagination } from '../../../../services/reportsGenerationService';
import { ModalResumoReportGeneration } from '../../reportsDetails/components/ModalResumoReportGeneration';
import listLayoutStyles from '../../../components/ListTableLayout/listTableLayout.module.css';

type Props = {
  className: string;
}

const PAGE_SIZE = 10

const TableReportsGeneration: React.FC<Props> = ({className}) => {
  const { toggleToast } = useToast();
  const [mySearch, setMySearch] = useState([]);
  const user = useAuth()
  const [control, setControl] = useState(false);
  //const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  //const [showCreateAppModalDelete, setShowCreateAppModalDelete] = useState<boolean>(false)
  const [showCreateAppModalDetails, setShowCreateAppModalDetails] = useState<boolean>(false)
  const [showCreateAppModalView, setShowCreateAppModalView] = useState<boolean>(false)
  const [myReport, setMyReport] = useState<any | null>(null);

  const [reports, setReports] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [filter, setFilter] = useState<string>(user.currentUser?.role.slug !== "CLIENTE" ? "INCOMPLETO" : "GERADO");
  const [filterNamePlant, setFilterNamePlant] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [largura, setLargura] = useState(window.innerWidth);

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: PAGE_SIZE,
    total: 0,
    qtdPages: 1
  });

  const [qtd, setQtd] = useState<any>({
    start: 0,
    end: PAGE_SIZE,
  });
    
  const getReports = async () => {
    try {
      setLoading(true)

      const reports = await getReportsGenerationAllPagination(
        filter, 
        selectedDate, 
        "", 
        filterNamePlant,
        pagination.limit, 
        pagination.page
      )

      setPagination({...pagination, qtdPages: reports.lastPage, total: reports.total})
      setReports(reports.data)


    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar relatórios. ", "error")
    }finally{
      setLoading(false)
    }
  }
    
  const refresh = () => {
    getReports()
  }

  const atualizarTamanhoDaTela = () => {
    setLargura(window.innerWidth);
  };

  useEffect(() => {
    getReports()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, filterNamePlant, selectedDate, pagination.page]);

  useEffect(() => {
    const start = pagination.total === 0 ? 0 : (pagination.page - 1) * pagination.limit + 1;
    const end = Math.min(pagination.page * pagination.limit, pagination.total);

    setQtd({start, end: end === 0 && pagination.total > 0 ? pagination.limit : end})
  }, [pagination.page, pagination.total, pagination.limit]);

  // useEffect(() => {
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedDate]);


  useEffect(() => {
    getReports();

    window.addEventListener('resize', atualizarTamanhoDaTela);
    return () => {
      window.removeEventListener('resize', atualizarTamanhoDaTela);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  
  
  // if(loading){
  //   return(
  //     <div style={{display: 'flex', justifyContent: 'center', height: '30rem', alignItems: 'center'}}>
  //       <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
  //     </div>
  //   )
  // }
  
  return (
    <div className={`card ${className} ${listLayoutStyles.listCard} pt-2`} style={{ minHeight: '60vh' }}>
      {/* begin::Header */}
      <div className={`card-header border-0`} style={{display: 'flex', flexDirection: 'row', marginBottom: '1rem'}}>
        <div 
          style={{
            display: 'flex', 
            gap: '1rem', 
            flexDirection: largura < 1200 ? 'column' : 'row', 
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
          }}>

          <div style={{display: 'flex', flexDirection: largura < 1200 ? 'column' : 'row', gap: '1.5rem', width: '100%'}}>
            <div style={{width: largura < 1200 ? '100%' : '15rem'}}>
              <DateSelector 
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              />
            </div>

            {largura > 1200 ? (
              <div className='card-toolbar nav nav-tabs' data-kt-buttons='true'>
                { user.currentUser?.role.slug !== "CLIENTE" &&
                  <a
                    className={`btn btn-sm btn-color-muted btn-active btn-active-warning active px-5 me-1 nav-item`}
                    data-bs-toggle="tab"
                    href="#"
                    onClick={()=> {
                      setFilter("INCOMPLETO")
                    }}
                  >
                    INCOMPLETO 
                    <span 
                      className='badge badge-dark'
                      style={{marginLeft: '10px'}}
                    >
                      {/* {alarmStatus.total} */}
                    </span>
                  </a>
                }
                <a
                  className={`btn btn-sm btn-color-muted btn-active btn-active-success ${user.currentUser?.role.slug === "CLIENTE" ? 'active' : ''} px-4 me-1 nav-item`}
                  data-bs-toggle="tab"
                  href="#"
                  onClick={()=> {
                    setFilter("GERADO")
                  }}
                >
                  GERADO
                  <span 
                    className='badge badge-success'
                    style={{marginLeft: '10px'}}
                  >
                    {/* {alarmStatus.normalNum} */}
                  </span>
                </a>
              </div>
            )
            :
            (
              <div className='me-0 dropdown' style={{width: '100%'}}>
                <button
                  //style={{color: 'white'}}
                  //disabled={loadingAvaiable || loading || report ? !report.template ? true : false : true}
                  className='btn btn-lg btn-secondary'
                  style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                  type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"
                >
                  <span>Buscar pelo Status </span>
                  <i className='bi bi-three-dots fs-3'></i>
                </button>

                <div className='dropdown-menu w-150px w-md-150px dropdown-menu-end' aria-labelledby="dropdownMenuButton1" style={{padding: '1rem'}}>
                  <div className='card-toolbar nav nav-tabs' data-kt-buttons='true'>
                    
                    <a
                      style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%'}}
                      className='btn btn-sm btn-color-muted btn-active btn-active-warning active px-4 me-1 nav-item'
                      
                      data-bs-toggle="tab"
                      href="#"
                      onClick={() => {
                        setFilter("INCOMPLETO")
                      }}

                    >
                      <span 
                        className='badge badge-warning'
                        style={{
                          marginLeft: '10px', 
                          padding: '0.5rem', 
                          width: '10rem',
                          display: 'flex',
                          alignItems: 'center', 
                          justifyContent: 'center'
                        }}
                      >
                        INCOMPLETOS
                      </span>
                    </a>
                    <a
                      style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%'}}
                      className='btn btn-sm btn-color-muted btn-active btn-active-success px-4 nav-item'
                      
                      data-bs-toggle="tab"
                      href="#"
                      onClick={() => {
                        setFilter("GERADO")
                      }}
                      
                    >
                      <span 
                        className='badge badge-success'
                        style={{
                          marginLeft: '10px', 
                          padding: '0.5rem', 
                          width: '10rem',
                          display: 'flex',
                          alignItems: 'center', 
                          justifyContent: 'center'
                        }}
                      >
                        GERADOS
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          {/* <SearchInput 
            className='form-control form-control-solid bg-body ps-14'
            placeholder='Buscar Relatórios'
            myDate={reports}
            setMySearch={setMySearch}
            control={control}
            style={{width: largura < 1200 ? "100%" : "300px"}}
            setControl={setControl}
            searchParameter="plant.name"
          /> */}

            <SearchInputV3
              className='form-control form-control-sm bg-light'
              placeholder={"Buscar por nome da usina"}
              setMySearch={setFilterNamePlant}
              setPagination={setPagination}
              style={{ 
                width: largura > 1200 ? "300px" : "100%",
                height: '3.5rem'
            }}
            />

        </div>
      </div>
      
      <div className='card-body py-3 pb-0' style={{ overflow: 'auto' }}>
        {/* begin::Table container */}
        <div className={`table-responsive ${listLayoutStyles.listTableWrap}`}>
          <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='text-muted text-start fw-bolder fs-7 text-uppercase gs-0'>
                {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div>
                </th> */}
                <th className='min-w-300px'>Usina</th>
                <th className='min-w-150px'>Mês</th>
                <th className='min-w-150px'>Status</th>
                {user.currentUser?.role.slug !== "CLIENTE" &&
                  <th className='min-w-40px text-end'>Actions</th>
                }
              </tr>
            </thead>
              {
                loading ? 
                  <tbody>
                    <tr>
                      <td colSpan={5} style={{textAlign: 'center', padding: '2rem'}}>
                        <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
                      </td>
                    </tr>
                  </tbody>
                : 
                  control === false ? (
                    <TableBody 
                      reports={reports} 
                      setMyReport={setMyReport}
                      myReport={myReport}
                      refresh={refresh}
                      //setShowCreateAppModal={setShowCreateAppModal}
                      //setShowCreateAppModalDelete={setShowCreateAppModalDelete}
                      setShowCreateAppModalView={setShowCreateAppModalView}
                      setShowCreateAppModalDetails={setShowCreateAppModalDetails}
                    />
                  )
                  : (
                    <TableBody 
                      reports={mySearch} 
                      setMyReport={setMyReport}
                      myReport={myReport}
                      refresh={refresh}
                      //setShowCreateAppModal={setShowCreateAppModal}
                      //setShowCreateAppModalDelete={setShowCreateAppModalDelete}
                      setShowCreateAppModalView={setShowCreateAppModalView}
                      setShowCreateAppModalDetails={setShowCreateAppModalDetails}
                    />
                  )
              }
          </table>
        </div>
      </div>

      <div className={`card-footer pt-0 pb-2 ${listLayoutStyles.listCardFooter}`}>
        <PaginationTablePlants 
          pagination={pagination}
          setPagination={setPagination}
          qtd={qtd}
        />
      </div>

     
        {<ModalResumoReportGeneration
          show={showCreateAppModalDetails}
          id={myReport ? myReport.id : undefined} 
          handleClose={() => {
            setMyReport(null)
            setShowCreateAppModalDetails(false)
            refresh()
          }} 
        />}

        {<ModalViewReport
          show={showCreateAppModalView}
          id={myReport ? myReport.id : undefined} 
          handleClose={() => {
            setMyReport(null)
            setShowCreateAppModalView(false)
            refresh()
          }} 
        />}
    </div>
  )
}

export {TableReportsGeneration}


